import React, { useEffect, useState } from "react";
import ModalComponent from "./ModalComponent";

export default function TodoComponent() {
  const [todos, setTodo] = useState([]);
  useEffect(() => {
    var archive = [],
      keys = Object.keys(localStorage),
      i = keys.length;

    while (i--) {
      archive.push(localStorage.getItem(keys[i]));
    }
    setTodo(archive);
  }, [setTodo]);

  return (
    <div className='todo'>
      <div className='card'>
        <div className='card-header'>
          <ModalComponent />
        </div>
        <div className='card-body'>
          <h5 className='card-title font-custom'>
            {new Date(Date.now()).toLocaleDateString()}
          </h5>
        </div>
        <ul className='list-group list-group-flush'>
          {todos.map((todo) => (
            <li className='list-group-item font-custom'>{todo}</li>
          ))}
        </ul>
      </div>
    </div>
  );
}
